<template>
  <div class="search-bar flex">
    <div v-if="search || label.id" class="search-keywords">
      <span v-if="label.id" class="topic-item-label">#{{label.name}}<i class="topic-item-label-cancel" @click="handleDeleteLabel">×</i></span>
      <span v-if="search" class="topic-item-label">{{search}}<i class="topic-item-label-cancel" @click="handleDeleteSearch">×</i></span>
    </div>
    <div v-else class="search-bar-tab">
      <span :class="activeTab === 1 ? 'active' : ''" @click="handleClickTab(1)">最新</span>
      <span :class="activeTab === 2 ? 'active' : ''" @click="handleClickTab(2)">最热</span>
    </div>
    <el-input class="input-border" v-model="search" placeholder="请输入您想搜索的内容">
      <i class="el-icon-search" slot="suffix"/>
    </el-input>
  </div>
</template>

<script>
export default {
    name: 'ForumSearch',
    props: {
      label: {
        type: Object,
        required: false,
        default: () => {},
      }
    },
    data: () => ({
      activeTab: 1, // 1最新  2 最热
      search: '', // 搜索内容
      labelInner: { id: ''}, // 话题标签
    }),
    watch: {
      activeTab() {
        this.emitSearch();
      },
      search() {
        this.emitSearch();
      },
      'label.id'() {
        this.labelInner = this.label;
        this.emitSearch();
      },
    },
    mounted() {
      this.emitSearch();
    },
    methods: {
      // 点击删除查询关键字
      handleDeleteSearch() {
        this.search = '';
      },
      // 切换tab查询条件
      handleClickTab(tab) {
        this.activeTab = tab;
      },
      // 触发查询回调
      emitSearch() {
        this.$emit('search', {
          orderBy: this.activeTab,
          search: this.search,
          label: this.labelInner,
        });
      },
      // 删除label
      handleDeleteLabel() {
        this.$emit('search', {
          orderBy: this.activeTab,
          search: this.search,
          label: { id: ''}
        });
      }
    }
}
</script>

<style lang="scss" scoped>
@import "../forum.scss";
.input-border.el-input {
  width: 47%;
}
.search-bar {
  padding: 10px 20px;
  align-items: center;
  border-radius: 4px 4px 0 0;
  background-color: #fff;
  border-bottom: 1px solid #EEF0FE;
  &-tab {
    font-size: 18px;
    color: #999;
    line-height: 40px;
    >span {
      margin-right: 25px;
      cursor: pointer;
      &.active {
        position: relative;
        color: #333;
        font-weight: 600;
        &::after {
          position: absolute;
          top: 41px;
          left: 50%;
          transform: translateX(-50%);
          display: block;
          background: #333;
          content: '';
          width: 20px;
          height: 4px;
        }
      }
    }
  }
}
</style>
